// TermsPrivacy.jsx
import React from "react";
import { useLocation, Link } from "react-router-dom";

export default function TermsPrivacy() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const type = params.get("type"); // "terms" أو "privacy"

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-3xl mx-auto bg-white p-8 rounded-2xl shadow-md">
        {/* العنوان */}
        <h1 className="text-3xl font-semibold mb-4">
          {type === "terms" && "Terms & Conditions"}
          {type === "privacy" && "Privacy Policy"}
          {!type && "Terms & Privacy"}
        </h1>

        {/* تاريخ آخر تحديث */}
        <p className="text-sm text-gray-400 mb-6">Last Updated: April 2026</p>

        {/* المحتوى */}
        <div className="space-y-5 text-gray-700 text-sm leading-6">
          {type === "terms" && (
            <>
              <p><strong>1. Introduction:</strong> By using Codical services, you agree to these terms.</p>
              <p><strong>2. Services:</strong> We provide software, marketing, and IT solutions.</p>
              <p><strong>3. User Responsibilities:</strong> You agree to lawful and proper usage.</p>
              <p><strong>4. Payments:</strong> Payments are required upfront or per agreement.</p>
              <p><strong>5. Intellectual Property:</strong> Ownership transfers after full payment.</p>
              <p><strong>6. Confidentiality:</strong> All shared information remains confidential.</p>
              <p><strong>7. Termination:</strong> We may suspend services for violations.</p>
              <p><strong>8. Liability:</strong> We are not responsible for indirect damages.</p>
            </>
          )}

          {type === "privacy" && (
            <>
              <p><strong>1. Data Collection:</strong> We collect basic user info like name and email.</p>
              <p><strong>2. Usage:</strong> Data is used to deliver and improve services.</p>
              <p><strong>3. Protection:</strong> We apply security measures to protect your data.</p>
              <p><strong>4. Sharing:</strong> We only share with trusted providers when needed.</p>
              <p><strong>5. Cookies:</strong> Used to enhance user experience.</p>
              <p><strong>6. Your Rights:</strong> You can request data access or deletion.</p>
              <p><strong>7. Updates:</strong> Policy may change over time.</p>
            </>
          )}

          {!type && (
            <p>
              الرجاء اختيار رابط من صفحة الموافقة على الشروط.
              <br />
              <Link to="/terms-consent" className="text-blue-600 underline">
                العودة لصفحة الموافقة
              </Link>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}